<div class="ui-expand-input-wrap {{align}}">
  <input type="text"
         class="form-control input-xl input-shadow ui-expand-input"
         [class.expand]="!!model"
         [placeholder]="placeholder"
         [(ngModel)]="model">
  <i class="icon-search search"></i>
</div>